import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../../store';
import { tenantScopeReset } from '../../Organizations/OrganizationsSlice/tenantScopeReset';

type ChatDetailsState = {
  isLoading: boolean;
  isError: string | null;
};

const initialState: ChatDetailsState = {
  isLoading: false,
  isError: null,
};

const messageDetailsSlice = createSlice({
  name: 'messageDetailsSlice',
  initialState: initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsError: (state, action: PayloadAction<string>) => {
      state.isError = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(tenantScopeReset, () => initialState);
  },
});

export const { setIsLoading, setIsError } = messageDetailsSlice.actions;

export const messageDetailsIsLoading = (state: RootState) => state.messageDetails.isLoading;

export default messageDetailsSlice.reducer;
